<template>
    <div>
        <v-card class="card--flex-toolbar">
            <v-card-text class="pa-0">
                <v-form ref="form">
                    <v-card flat>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <!-- Widget Type -->
                                    <v-select
                                        class="mx-2"
                                        outline
                                        v-model="widget.type"
                                        :items="widgetTypes"
                                        :label="'Widget Type'"
                                        item-text="text"
                                        item-value="value"
                                        hide-details
                                        color="saSecondary"
                                        prepend-inner-icon="$vuetify.icons.rms_agreement"
                                        disabled
                                    ></v-select>
                                </v-flex>
                            </v-layout>

                            <!-- Widget Name In Translation -->
                            <v-layout>
                                <v-flex xs12 md12 lg12 class="px-2 py-3">
                                    <v-card elevation="2">
                                        <v-card-title>
                                            <v-layout wrap row>
                                                <v-flex xs8>
                                                    <v-tabs
                                                        background-color="transparent"
                                                        color="basil"
                                                        grow
                                                        v-model="widget_language"
                                                    >
                                                        <v-tab
                                                        v-for="language in enabledLanguages" :key="language.text"
                                                        >
                                                            {{ language.text }}
                                                        </v-tab>
                                                    </v-tabs>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div style="float: right;" v-if="widget_language === 0">
                                                        <v-tooltip 
                                                                bottom
                                                                max-width="300"
                                                                color="grey darken-3"
                                                            >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    color="grey lighten-3"
                                                                    class="override-btn"
                                                                    outlined
                                                                    style="float:right"
                                                                    small
                                                                    @click="setFieldLanguageData(['name','content','copyright_text'],widget)"
                                                                >
                                                                {{ $t('language_copy_all_button_label') }}
                                                                </v-btn>
                                                                </template>
                                                                <div class="pa-2">
                                                                <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                                                                </div>
                                                        </v-tooltip>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-title>
                                        <v-tabs-items v-model="widget_language">
                                            <v-tab-item
                                                v-for="language in enabledLanguages"
                                                :key="language.text"
                                            >
                                            <v-card
                                                color="basil"
                                                flat
                                            >
                                                <v-card-text>
                                                    <v-flex xs12 md6 lg12 class="px-2">
                                                    <!-- Name -->
                                                        <v-text-field
                                                            class="mx-2"
                                                            id="name"
                                                            :label="$t('widget.save.form.name') + ' in ' + language.text"
                                                            v-model="widget.name[language.value]" 
                                                            :name="`title_${language.value}`"
                                                            :rules="[
                                                                rules.min_length(3),
                                                                rules.max_length(255),
                                                            ]"
                                                            counter="255"
                                                            color="primary"
                                                            prepend-inner-icon="$vuetify.icons.rms_agreement"
                                                            type="text"
                                                            outline
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 class="px-2">
                                                        <v-textarea outline
                                                            :label="`Description in ${language.text}`"
                                                            :name="`description_${language.value}`"
                                                            v-model="widget.content[language.value]" 
                                                            class="mx-2"
                                                        />
                                                    </v-flex>
                                                    <v-flex xs12 class="px-2" v-if="widget.type == DEFINES.WIDGETS.TYPE_FOOTER">
                                                        <div class="mt-3">
                                                            <!-- Copyrights Text -->
                                                            <v-text-field
                                                                :id="`copyright_text_${language.value}`"
                                                                :label="`Copyrights Text in ${language.text}`"
                                                                :name="`copyright_text_${language.value}`"
                                                                color="primary"
                                                                v-model="widget.copyright_text[language.value]"
                                                                prepend-inner-icon="$vuetify.icons.rms_agreement"
                                                                type="text"
                                                                outline
                                                            />
                                                        </div>
                                                    </v-flex>
                                                </v-card-text>
                                            </v-card>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                            <!-- Widget Name In Translation -->

                            <!-- Widget Slug -->
                             <v-flex xs12 md6 lg12 class="px-2">
                                <v-text-field
                                    class="mx-2"
                                    id="slug"
                                    :label="'Widget Slug'"
                                    v-model="widget.slug" 
                                    :name="`Slug`"
                                    :rules="[
                                        rules.min_length(3),
                                        rules.max_length(255),
                                    ]"
                                    counter="255"
                                    color="primary"
                                    prepend-inner-icon="$vuetify.icons.rms_agreement"
                                    type="text"
                                    outline
                                ></v-text-field>
                            </v-flex>
                            <!-- Widget Slug -->

                            <!-- Header Configuration -->
                            <div v-if="widget.type == DEFINES.WIDGETS.TYPE_HEADER">
                                <!-- Logo -->
                                <v-checkbox hide-details v-model="widget.configurations.show_logo" color="primary" label="Show Logo / Branding"></v-checkbox>
                                <!-- Search Bar -->
                                <v-checkbox hide-details v-model="widget.configurations.search_bar" color="primary" label="Enable Search Bar"></v-checkbox>
                                <!-- Enable Navigation Links -->
                                <div class="d-inline-flex">
                                    <v-checkbox color="primary" hide-details v-model="widget.configurations.show_navigation_links" label="Show Navigation Links"></v-checkbox>
                                    <v-btn v-if="widget.configurations.show_navigation_links" class="ml-2 mt-3" small  @click.stop="addLink()" color="primary" >+ Add Link</v-btn>
                                </div>
                                <div v-if="widget.configurations.show_navigation_links">
                                    <v-layout v-for="link,index in widget.data.navigation_links" :key="index">
                                        <!-- Link Name -->
                                        <v-flex xs12 sm12 md3 lg3>
                                            <v-text-field
                                                :id="'text-'+index"
                                                :label="'Title'"
                                                name="text"
                                                :rules="[
                                                    rules.required,
                                                    rules.min_length(3),
                                                    rules.max_length(255),
                                                ]"
                                                counter="255"
                                                color="primary"
                                                prepend-icon="$vuetify.icons.rms_agreement"
                                                type="text"
                                                class="pr-3"
                                                v-model="link.text"
                                            ></v-text-field>
                                        </v-flex>
                                        <!-- URL Input -->
                                        <v-flex xs12 sm12 md6 lg6>
                                            <v-text-field
                                                :id="'link-'+index"
                                                :label="'Link'"
                                                name="link"
                                                :rules="[rules.required]"
                                                color="primary"
                                                prepend-icon="$vuetify.icons.rms_agreement"
                                                type="text"
                                                class="pr-3"
                                                v-model="link.link"
                                            ></v-text-field>
                                        </v-flex>
                                        <!-- Tab Selection -->
                                        <v-flex xs12 sm12 md2 lg2>
                                            <v-select
                                            v-model="link.target"
                                            :items="[{'value':'_self', 'text':'Same Tab'}, {'value':'_blank', 'text':'New Tab'}]"
                                            label="Opens In"
                                            class="pr-3"
                                            ></v-select>
                                        </v-flex>
                                        <!-- Delete Link -->
                                        <v-flex xs12 sm12 md1 lg1 class="text-xs-center">
                                            <v-btn @click="deleteLink(index)" color="error" small icon fab><v-icon>mdi-delete</v-icon></v-btn>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </div>
                            <!-- Footer Configuration -->
                            <div v-if="widget.type == DEFINES.WIDGETS.TYPE_FOOTER">
                                <FooterWidgetConfiguration 
                                    ref="footer_widget"
                                    :widget.sync="widget" 
                                    
                                />
                                <!-- Show Copyrights -->
                                <!-- <v-checkbox hide-details v-model="widget.configurations.copyrights" color="primary" label="Show Copyrights"></v-checkbox>
                                <div class="mt-3" v-if="widget.configurations.copyrights">
                                    <v-text-field
                                        v-model="widget.data.copyrights_text"
                                        id="copyright_text"
                                        :label="'Copyrights Text'"
                                        name="copyright_text"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                </div> -->
                                <!-- Enable Navigation Links -->
                                <!-- <div class="d-inline-flex">
                                    <v-btn class="ml-2 mt-3" small  @click.stop="addLink()" color="primary" >+ Add Quick Links</v-btn>
                                </div> -->
                                
                                <!-- Show Social Media Links -->
                                <!-- <v-checkbox hide-details v-model="widget.configurations.social_media_links" color="primary" label="Show Social Media Links"></v-checkbox>
                                <div class="mt-3" v-if="widget.configurations.social_media_links">
                                    <v-text-field
                                        v-model="widget.data.social_media_links.linkedin"
                                        id="linkedin_url"
                                        :label="'Linkedin URL'"
                                        name="linkedin_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="widget.data.social_media_links.twitter"
                                        id="twitter_url"
                                        :label="'Twitter URL'"
                                        name="twitter_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="widget.data.social_media_links.facebook"
                                        id="facebook_url"
                                        :label="'Facebook URL'"
                                        name="facebook_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="widget.data.social_media_links.instagram"
                                        id="instagram_url"
                                        :label="'Instagram URL'"
                                        name="instagram_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="widget.data.social_media_links.youtube"
                                        id="youtube_url"
                                        :label="'Youtube URL'"
                                        name="youtube_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="widget.data.social_media_links.google_play"
                                        id="google_play_url"
                                        :label="'Google Play URL'"
                                        name="google_play_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                    <v-text-field
                                        v-model="widget.data.social_media_links.app_store"
                                        id="app_store_url"
                                        :label="'App Store URL'"
                                        name="app_store_url"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                </div> -->

                                <!-- Show Contact / Support Mail -->
                                <!-- <v-checkbox hide-details v-model="widget.configurations.contact_mail" color="primary" label="Show Contact / Support Mail"></v-checkbox> -->
                                <div class="mt-3">
                                    <v-text-field
                                        v-model="widget.data.contact_mail"
                                        id="contact_mail"
                                        :label="'Contact / Support Mail'"
                                        name="contact_mail"
                                        color="primary"
                                        prepend-icon="$vuetify.icons.rms_agreement"
                                        type="text"
                                    ></v-text-field>
                                </div>
                            </div>
                            <!-- Tag widget -->
                            <div v-if="widget && widget.type == DEFINES.WIDGETS.TYPE_TAG" class="px-2">
                                <v-combobox
                                    v-model="widget.data.tags"
                                    :items="tags"
                                    :search-input.sync="tagSearch"
                                    hide-selected
                                    :label="$t('admin.page.widget.customize.tag.selection.label')"
                                    :hint="$t('admin.page.widget.customize.tag.selection.hint')"
                                    multiple
                                    outline
                                    persistent-hint
                                    small-chips
                                    item-text="name"
                                >
                                    <!-- <template v-slot:selection="{item}">
                                        <div>{{ item.id }}</div>
                                    </template> -->
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    No results matching "<strong>{{ tagSearch }}</strong>". Press <kbd>enter</kbd> to create a new one
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    </v-combobox>
                            </div>
                            <div v-if="widget && widget.type == DEFINES.WIDGETS.TYPE_CONTENT" class="px-2">
                                <div class="grey--text text--darken-4">{{ $t('admin.page.widget.configuration.content.visibility.radio.btn.label') }}</div>
                                <v-radio-group
                                    v-model="widget.configurations.visibility"
                                    row
                                >
                                    <v-radio
                                        :label="$t('admin.page.widget.configuration.content.visibility.radio.btn.carousal.label')"
                                        value="carousal"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('admin.page.widget.configuration.content.visibility.radio.btn.grid.label')"
                                        value="grid"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('admin.page.widget.configuration.content.visibility.radio.btn.slider.label')"
                                        value="slider"
                                    ></v-radio>
                                    <v-radio
                                        :label="$t('admin.page.widget.configuration.content.visibility.radio.btn.sliding.card.label')"
                                        value="sliding-card"
                                    ></v-radio>

                                </v-radio-group>
                            </div>
                            <!-- Published -->
                            <v-checkbox v-model="widget.published" color="primary">
                                <template v-slot:label>
                                    <div>{{ widget.published?$t('widget.save.form.published'):$t('widget.save.form.unpublished') }}</div>
                                </template>
                                <template v-slot:append>
                                    <v-tooltip top color="white">
                                        <template v-slot:activator="{on}">
                                            <v-icon v-on="on">mdi-information-outline</v-icon>
                                        </template>
                                        <div class="grey--text text--darken-3 body-1">{{ $t('widget.save.form.published.tooltip') }}</div>
                                    </v-tooltip>
                                </template>
                            </v-checkbox>
                        </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                    <v-card-actions class="pa-3">
                        <v-spacer></v-spacer>
                        <v-btn @click="$router.push({name: 'AdminWidgetList'})" color="grey" dark>{{ $t('rms.button.cancel') }}</v-btn>
                        <v-btn @click="save((widget.id != undefined)?'update':'create')" color="secondary" dark>{{ (widget.id != undefined)?$t('rms.button.update'):$t('rms.button.create') }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import Vue from 'vue';
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import TextEditor from "@/components/TextEditor";
import { Integer } from 'read-excel-file';
// import from local copy
import FooterWidgetConfiguration from "@/components/widget/FooterWidgetConfiguration"


export default {
    name: "AdminWidgetSave",
    props: {
        widget: {
            type: Object,
            default: {}
        }
    },
    components: {
        TextEditor,
        FooterWidgetConfiguration
    },
    data() {
        return {
            rules,
            screeners:[],
            tags: [],
            tagSearch: null,
            widget_language:null,
            languages:DEFINES.LOCALES
        };
    },
    mounted() {
        this.bootstrap()
    },
    computed: {
        ...mapState({
            company: (state) => state.company.company,
        }),
        widgetTypes(){
            return Object.entries(DEFINES.WIDGETS.TYPES).map(function(type){
                return {
                    'value':parseInt(type[0]),
                    'text':type[1]
                }
            });
        },
        enabledLanguages() {
            return DEFINES.LOCALES
        }
    },
    methods: {
        async bootstrap() {
            await this.getAllTags()
        },

        async getAllTags() {
            await this.$store.dispatch('tag/listAll')
            .then((response) => {
                this.tags = response.tags && response.tags.vod_random ? response.tags.vod_random : []
            })
        },

        async save(operation)
        {
            if (!this.$refs.form.validate()) {
                return false;
            }
            try {
                // Add Data from Footer Component into the Widget data attribute

                this.widget.data.quick_links = (this.$refs.footer_widget) ? this.$refs.footer_widget.QuickLinks : [];
                this.widget.data.legal_links = (this.$refs.footer_widget) ? this.$refs.footer_widget.LegalLinks : [];
                this.widget.data.social_medias_links = (this.$refs.footer_widget) ? this.$refs.footer_widget.SocalMediaLinks : []

                var response = await this.$store.dispatch("adminWidget/" + operation, this.widget);
                this.$router.push({name: "AdminWidgetList" });
                this.$store.dispatch("app/showMessage", {
                message: i18n.t("widget.save.success.message"),
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            }
        },
        async getVodEvents() {
            try {
                var response = await this.$store.dispatch("adminScreener/listVodEvents",{});
                this.screeners = response.screeners;
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error",
                });
            }
        },
        removeSelectedScreener(screener) {
            const index = this.widget.screener_ids.indexOf(screener.id);
            if (index >= 0) this.widget.screener_ids.splice(index, 1);
        },
        addSelectedScreener(screener){
            // If already there, remove it
            if(this.widget.screener_ids.includes(screener.id)){
                return this.removeSelectedScreener(screener);
            }
            this.widget.screener_ids.push(screener.id);
        },
        __makeNavigationLink(){
            return {
                'text':'',
                'link':null,
                'target':'_self'
            }
        },
        addLink(){
            if(this.widget.data.navigation_links){
                this.widget.data.navigation_links.push(this.__makeNavigationLink());
            }
        },
        deleteLink(position){
            if(this.widget.data.navigation_links && this.widget.data.navigation_links.length){
                this.widget.data.navigation_links = this.widget.data.navigation_links.filter((link, index) => (index != position));
            }
        },
        setFieldLanguageData(fields, stateObject) {
            let __this = this
            fields.forEach(field => {
            __this.enabledLanguages.forEach((lang) => {
                if (lang.value !== 'en') {
                    stateObject[field][lang.value] = stateObject[field]['en']
                }
                });
            });
        }
    }
};
</script>
